import { AnalyticEventName, track } from 'src/core/utils/analytics';

export function trackPayablesFiltersChanged(type: string): void {
  track(AnalyticEventName.BOOKKEEP_PAYABLE_ALL_FILTERING_CHANGED, {
    type,
  });
}
